var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionRolesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Permission_Roles_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Permission_Roles_Active",
    "data-name": "Permission Roles_Active",
    clipPath: "url(#clip-Permission_Roles_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Permission_Roles",
    "data-name": "Permission Roles",
    transform: "translate(4 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_45",
    "data-name": "Subtraction 45",
    d: "M-1403.164-582.483h-20.246a1.592,1.592,0,0,1-1.589-1.59V-600.41a1.592,1.592,0,0,1,1.589-1.59h20.246a1.592,1.592,0,0,1,1.589,1.59v16.337A1.592,1.592,0,0,1-1403.164-582.483Zm-10.123-15.61a6.13,6.13,0,0,0-6.269,5.964,6.13,6.13,0,0,0,6.269,5.964,6.13,6.13,0,0,0,6.269-5.964A6.13,6.13,0,0,0-1413.287-598.093Z",
    transform: "translate(1425.727 611.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2165",
    "data-name": "Group 2165",
    transform: "translate(0 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4742",
    "data-name": "Path 4742",
    d: "M29.78,33.416H12.959A4.013,4.013,0,0,1,8.93,29.441V16.405a4.013,4.013,0,0,1,4.029-3.975H29.78a4.013,4.013,0,0,1,4.029,3.975.7.7,0,0,1-1.408,0,2.611,2.611,0,0,0-2.622-2.586H12.959a2.611,2.611,0,0,0-2.622,2.586V29.441a2.611,2.611,0,0,0,2.622,2.586H29.78A2.611,2.611,0,0,0,32.4,29.441V21.283a.7.7,0,0,1,1.408,0v8.158A4.013,4.013,0,0,1,29.78,33.416Z",
    transform: "translate(-8.93 -12.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4743",
    "data-name": "Path 4743",
    d: "M23,17.218a.729.729,0,0,1-.727-.727v-.055a.727.727,0,1,1,1.454,0v.055A.729.729,0,0,1,23,17.218Z",
    transform: "translate(1.156 -10.036)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4744",
    "data-name": "Path 4744",
    d: "M13.141,17.792a.707.707,0,0,1-.681-.727V13.921A6.259,6.259,0,0,1,18.5,7.47a6.259,6.259,0,0,1,6.043,6.451.682.682,0,1,1-1.362,0A4.837,4.837,0,0,0,18.52,8.942a4.837,4.837,0,0,0-4.664,4.979v3.144a.707.707,0,0,1-.681.727Z",
    transform: "translate(-6.045 -7.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2166",
    "data-name": "Group 2166",
    transform: "translate(5.425 12.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4745",
    "data-name": "Path 4745",
    d: "M19.155,28.71a7.015,7.015,0,1,1,7.015-7.015A7.019,7.019,0,0,1,19.155,28.71Zm0-12.557A5.543,5.543,0,1,0,24.7,21.695a5.553,5.553,0,0,0-5.543-5.543Z",
    transform: "translate(-12.14 -14.68)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4746",
    "data-name": "Path 4746",
    d: "M16.543,21.672h0a.66.66,0,0,1-.509-.218l-1.4-1.417A.732.732,0,0,1,15.671,19l.89.89,2.362-2.326A.732.732,0,0,1,19.96,18.6l-2.871,2.835a.8.8,0,0,1-.509.218Z",
    transform: "translate(-4.849 -0.055)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionRolesActive);
export default __webpack_public_path__ + "static/media/Permission_Roles_Active.cff5f11c8b7eff49ea9b3d6940367f8b.svg";
export { ForwardRef as ReactComponent };